
























import { Component, Prop, Vue } from 'vue-property-decorator'

import { KoejaksonVaiheHyvaksynta } from '@/types'

@Component({})
export default class KoejaksonVaiheHyvaksynnat extends Vue {
  @Prop({ required: true, default: [] })
  hyvaksynnat!: KoejaksonVaiheHyvaksynta[] | null

  @Prop({ required: false, default: 'muokkauspaivamaarat' })
  title!: string

  get showHyvaksynnat() {
    return this.hyvaksynnat ? this.hyvaksynnat.length > 0 : false
  }
}
